import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { ProgressCircle } from "react-native-svg-charts";
import differenceInSeconds from "date-fns/differenceInSeconds";
import { attributes } from "../../theme";

const calculateProgress = ({ length, nextEvent }) => {
  const differenceNow =
    length - differenceInSeconds(new Date(nextEvent), new Date());

  const progress = differenceNow / length;

  return progress;
};

const tick = (props, setState) => {
  setState({
    progress: calculateProgress(props)
  });
};

const RunningGame = props => {
  const { length, nextEvent } = props;

  const [state, setState] = useState({
    progress: calculateProgress({ length, nextEvent })
  });

  useEffect(() => {
    const interval = setInterval(() => {
      tick({ length, nextEvent }, setState);
    }, 1000);
    return () => clearInterval(interval);
  });

  return (
    <View>
      <ProgressCircle
        style={{ height: 200 }}
        progress={state.progress}
        progressColor={attributes.mainColor}
      />
    </View>
  );
};

export default RunningGame;
